

















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosTrack } from '@/services/api.service';
import MelosInput from '@/components/MelosInput.vue';
import MelosButton from '@/components/MelosButton.vue';
import MelosButtonSet from '@/components/MelosButtonSet.vue';
import MelosCover from '@/components/MelosCover.vue';
import _ from 'lodash';

@Component({
  components: {
    MelosInput,
    MelosButton,
    MelosCover,
    MelosButtonSet,
  },
})
export default class TrackDetails extends Vue {
  private tags: string[] = [];
  private originalTags: string[] = [];
  private artist: string | undefined | any = {};
  private debouncedTagChangeHandler: any = _.debounce(this.onTagsChanged, 1000);
  private debouncedTrackChangeHandler: any = _.debounce(this.updateTrackData, 1000);
  private updateEventCount = 0;
  private coverDateString = new Date().getTime();
  private reloadingCover: boolean = false;

  private async mounted() {
    this.tags = this.getTags();
    this.originalTags = [ ...this.tags ];
    this.artist = this.getArtist();
    if (this.trackData === undefined) {
      await this.fetchContent();
    }
  }

  private get multiple(): boolean {
    return this.$route.params.trackId === undefined;
  }

  private get trackData(): MelosTrack {
    if (this.multiple) {
      return this.trackList[0];
    }
    return this.$store.state.ownedTracks.find((track: MelosTrack) => {
      return track.id === this.$route.params.trackId;
    });
  }

  private get trackList(): MelosTrack[] {
    return this.$store.state.ownedTracks.filter((track: MelosTrack) => {
      return (this.$store.state.checkedItems || []).includes(track.id);
    });
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private async onCoverInputChanged() {
    const files = ((this.$refs.coverInput as any).files || []);
    if (files.length > 0) {
      const file = files[0];
      await this.$apiService.uploadTrackCover(this.trackData.id || '', file);
      this.coverDateString = new Date().getTime();
      this.fetchContent();
    }
  }

  private async onCoverOptionClick(index: number) {
    switch (index) {
      case 0:
        (this.$refs.coverInput as any).click();
        break;
      case 1:
        await this.$apiService.fetchTrackCover(this.trackData.id || '');
        break;
      case 2:
        await this.$apiService.removeTrackCover(this.trackData.id || '');
        break;
    }
    this.coverDateString = new Date().getTime();
    this.fetchContent();
  }

  private async fetchContent() {
    const ownedStations = (await this.$apiService.getStations())
   .filter((station) => station.owner === this.$store.state.session?.userId);
    const ownedTracks = await this.$apiService.getTracks();
    this.$store.commit('setOwnedStations', ownedStations);
    this.$store.commit('setOwnedTracks', ownedTracks);
  }

  private async addNewTag() {
    this.tags.push('');
    if (this.multiple) {
      for (const track of (this.trackList || [])) {
        (track.tags as string[]).push('');
        this.$apiService.updateTrack(track);
      }
    }
  }

  private async removeTag(index: number, tag: string) {
    this.tags.splice(index, 1);
    for (const track of (this.trackList || [])) {
      (track.tags as string[]).splice(index, 1);
      this.$apiService.updateTrack(track);
    }
  }

  private getTags(): string[] {
    if (!this.multiple) {
      return (this.trackData?.tags as string[]) || [];
    }
    if (this.trackList.length === 0) {
      return [];
    }
    return (this.trackList[0].tags as string[]).filter((tag: string) => {
      let i;
      for (i = 1; i < this.trackList.length && (this.trackList[i]?.tags as string[] || []).includes(tag); i++);
      return i === this.trackList.length;
    });
  }

  private getArtist(): string | undefined {
    if (!this.multiple) {
      return this.trackData?.artist || '';
    }
    if (this.trackList.length === 0) {
      return;
    }
    const firstArtist = this.trackList[0].artist;
    let i;
    for (i = 1; i < this.trackList.length && this.trackList[i].artist === firstArtist; i++);
    return i === this.trackList.length ? firstArtist || '' : undefined;
  }

  @Watch('trackData.title')
  @Watch('artist')
  private async handleTrackUpdate() {
    if (this.updateEventCount < 2) {
      this.updateEventCount ++;
      return;
    }
    return this.debouncedTrackChangeHandler();
  }

  private async updateTrackData() {
    if (!this.multiple && this.trackData !== undefined) {
      this.trackData.artist = this.artist;
      return this.$apiService.updateTrack(this.trackData);
    } else {
      for (const track of this.trackList) {
        track.artist = this.artist;
        this.$apiService.updateTrack(track);
      }
    }
  }

  @Watch('tags')
  private async handleTagChange() {
    if (this.updateEventCount < 2) {
      this.updateEventCount ++;
      return;
    }
    return this.debouncedTagChangeHandler();
  }

  private async onTagsChanged() {
    if (!this.multiple && this.trackData !== undefined) {
      this.trackData.tags = this.tags;
      return this.$apiService.updateTrack(this.trackData);
    } else if (this.multiple && this.tags.length === this.originalTags.length) {
      // Find tag that changed it's value
      const updatedTagIndex = this.originalTags.findIndex((tag) => !this.tags.includes(tag));
      const oldTagValue = this.originalTags[updatedTagIndex];
      const newTagValue = this.tags[updatedTagIndex];
      for (const track of this.trackList) {
        const tagIndex = (track.tags as string[]).findIndex((tag: string) => tag === oldTagValue);
        (track.tags as string [])[tagIndex] = newTagValue;
        this.$apiService.updateTrack(track);
      }
    }
    this.originalTags = [ ...this.tags ];
  }

  private getFormattedTime(time: number): string {
    const minutes = String(Math.round(time / 60)).padStart(2, '0');
    const seconds = String(Math.round(time % 60)).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }
}

